import { createBrowserRouter } from "react-router-dom";

import { withFaroRouterInstrumentation } from "@grafana/faro-react";
import { createRouterObservers } from "@honeycomb/mystique";

import { routes } from "./routes";

export const router = createBrowserRouter(routes());

withFaroRouterInstrumentation(router);
createRouterObservers(router);
